module.exports = __webpack_public_path__ + "static/NotoSansThai-Bold-eaaaa173feb41fc82a574ca85b082e12.ttf";